import { latLng, latLngBounds, LatLngBounds } from 'leaflet'
import { ILatLng } from './latLng.interface'

export class LocationClass implements ILatLng {
  latitude = 0
  longitude = 0
  address = ''
  country = ''
  viewBounds: LatLngBounds = latLngBounds(latLng(0, 0), latLng(0, 0))
}
